import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "@/store/auth";
const routes = [

  // 旅客建议收集页面
  {
    path: "/",
    name: "suggest",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/suggestCollect.vue"),
  },
  {
    path: "/select",
    name: "select",
    component: () =>
        import(/* webpackChunkName: "about" */ "../views/vanSelect.vue"),
  }


];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHistory("/suggest"),
  routes,
});


export default router;
